/**
 * Рубежи в адресе для разделов, у которых схема адреса своя и о рубежах не
 * знает («Спутники»). Ключи ТЕ ЖЕ, что у «Буёв» и «Скаута» (`eez`, `fd`): одна
 * и та же ссылка включает одно и то же, в каком бы разделе её ни открыли.
 *
 * Строгое сравнение с «1», а не «непустая строка»: ссылка приходит извне, а
 * рубежи перекрывают карту линиями, которых человек не просил.
 */
import type { BoundaryToggles } from './useBoundaryOverlays'

export const BOUNDARY_URL_KEYS = ['eez', 'fd'] as const

export function parseBoundaryUrl(params: URLSearchParams): BoundaryToggles {
  return { eez: params.get('eez') === '1', districts: params.get('fd') === '1' }
}

/** Новый набор параметров: свои ключи переписаны, чужие не тронуты. */
export function writeBoundaryUrl(params: URLSearchParams, s: BoundaryToggles): URLSearchParams {
  const out = new URLSearchParams(params)
  if (s.eez) out.set('eez', '1')
  else out.delete('eez')
  if (s.districts) out.set('fd', '1')
  else out.delete('fd')
  return out
}
